import { isDineInOrderFlow } from '@local/utils';
import { Restaurant } from '@local/api';
import { FulfillMethod } from 'types/order';

export const isCurbsideAvailableNow = (
  restaurant: Pick<Restaurant, 'allows_order_for_now' | 'fulfillment'>
): boolean => {
  return (
    !!restaurant.allows_order_for_now &&
    !!restaurant?.fulfillment?.curbside?.is_available_now
  );
};

export const isCurbsideAheadAvailable = (
  restaurant: Pick<Restaurant, 'order_ahead'>
): boolean => {
  return !!restaurant?.order_ahead?.is_curbside_ahead_available;
};

export const isDeliveryAvailableNow = (
  restaurant: Pick<Restaurant, 'allows_order_for_now' | 'fulfillment'>
): boolean => {
  return (
    !!restaurant.allows_order_for_now &&
    !!restaurant?.fulfillment?.delivery?.is_available_now
  );
};

export const isDeliveryAheadAvailable = (
  restaurant: Pick<Restaurant, 'order_ahead'>
): boolean => {
  return !!restaurant?.order_ahead?.is_delivery_ahead_available;
};

export const isDineInAvailableNow = (
  restaurant: Pick<Restaurant, 'allows_order_for_now' | 'fulfillment'>
): boolean => {
  return (
    !!restaurant.allows_order_for_now &&
    !!restaurant?.fulfillment?.dine_in?.is_available_now
  );
};

export const isDineInAheadAvailable = (
  restaurant: Pick<Restaurant, 'order_ahead'>
): boolean => {
  return !!restaurant?.order_ahead?.is_dine_in_ahead_available;
};

export const isPickupAvailableNow = (
  restaurant: Pick<Restaurant, 'allows_order_for_now' | 'fulfillment'>
): boolean => {
  return (
    !!restaurant.allows_order_for_now &&
    !!restaurant?.fulfillment?.pickup?.is_available_now
  );
};

export const isPickupAheadAvailable = (
  restaurant: Pick<Restaurant, 'order_ahead'>
): boolean => {
  return !!restaurant?.order_ahead?.is_pickup_ahead_available;
};

export const isFulfillmentMethodAheadAvailable = (
  fulfillmentMethod: FulfillMethod,
  restaurant: Pick<Restaurant, 'order_ahead'>
): boolean => {
  switch (fulfillmentMethod) {
    case 'curbside':
      return isCurbsideAheadAvailable(restaurant);
    case 'delivery':
      return isDeliveryAheadAvailable(restaurant);
    case 'dine_in':
      return isDineInAheadAvailable(restaurant);
    case 'pickup':
      return isPickupAheadAvailable(restaurant);
    default:
      return false;
  }
};

export const isFulfillmentMethodAvailableNow = (
  fulfillmentMethod: FulfillMethod,
  restaurant: Pick<Restaurant, 'allows_order_for_now' | 'fulfillment'>
): boolean => {
  switch (fulfillmentMethod) {
    case 'curbside':
      return isCurbsideAvailableNow(restaurant);
    case 'delivery':
      return isDeliveryAvailableNow(restaurant);
    case 'dine_in':
      return isDineInAvailableNow(restaurant);
    case 'pickup':
      return isPickupAvailableNow(restaurant);
    default:
      return false;
  }
};

export const isClosed = (
  restaurant: Pick<
    Restaurant,
    'allows_order_for_now' | 'fulfillment' | 'order_ahead'
  >
): boolean => {
  if (isDineInOrderFlow() && !isDineInAvailableNow(restaurant)) {
    return true;
  }

  return (
    !isPickupAvailableNow(restaurant) &&
    !isDeliveryAvailableNow(restaurant) &&
    !isPickupAheadAvailable(restaurant) &&
    !isDeliveryAheadAvailable(restaurant)
  );
};
